<template>
    <div class="privateLetter">
     <!-- 富文本编辑器 -->
     <Editor id="tinymce" v-model="tinymceHtml" :init="editorInit" :key="tinymceFlag"></Editor>
    </div>
  </template>
  <script>
  import axios from "axios";
  import { S4 } from "@/utils/utils.js";
  import tinymce from 'tinymce/tinymce'
  import Editor from '@tinymce/tinymce-vue'
  import 'tinymce/themes/silver'
  import 'tinymce/plugins/textcolor'
  import 'tinymce/plugins/advlist'
  import 'tinymce/plugins/table'
  import 'tinymce/plugins/lists'
  import 'tinymce/plugins/paste'
  import 'tinymce/plugins/preview'
  import 'tinymce/plugins/fullscreen'
  import 'tinymce/plugins/save'
  import 'tinymce/plugins/image'
//   import 'tinymce/icons/default/icons'
  export default {
    components: {
      Editor
    },
    props:{
        editorHeight: {
            type: Number,
            default: 360,
        },
        ossData: Object,
        ossObj: Object,
        initHtml: {
            type: String,
            default: "",
        },
    },
    data () {
      return {
        tinymceFlag: 1,
        tinymceHtml: "",
        editorInit: {
          language_url: '/tinymce/langs/zh_CN.js',
          language: 'zh_CN',
          skin_url: '/tinymce/skins/ui/oxide',
          content_css: "/tinymce/skins/content/default/content.css",
          height: this.editorHeight,
          browser_spellcheck: true, // 拼写检查
          branding: false, // 去水印
          elementpath: false, // 禁用编辑器底部的状态栏
          statusbar: false, // 隐藏编辑器底部的状态栏
          paste_data_images: true, // 允许粘贴图像
          menubar: true, // 隐藏最上方menu
          plugins: 'save advlist table lists paste preview fullscreen image',
          toolbar: 'fontselect fontsizeselect forecolor backcolor bold italic underline fullscreen strikethrough save image| alignleft aligncenter alignright alignjustify | quicklink h2 h3 blockquote table numlist bullist preview',
          images_upload_handler: this.imagesUploadHandler,
          paste_preprocess: function () {
            // console.log('---paster')
          }
        },
      }
    },
    mounted () {
      tinymce.init({})
      this.tinymceHtml = this.initHtml
    },
    activated () {
      this.tinymceFlag++
    },
    watch:{
        // 处理编辑器内容变化
        tinymceHtml: function(val) {
        this.$emit("handleTinymceInput", val);
        },
    },
    methods: {
        async imagesUploadHandler(blobInfo, success) {
            let formData = new FormData();
            for (let key in this.ossData) {
                formData.append(key, this.ossData[key]);
            }
            //   console.log(blobInfo.blob());
            const time = new Date().getTime();
            //   let key = `${this.ossObj.dir}${time}_${S4()}`;
            // console.log(time, S4());
            let key = `${this.ossObj.dir}${time}_${S4()}` + `${blobInfo.blob().name}`;
            formData.append("key", key);
            formData.append("file", blobInfo.blob());
            let url = this.ossObj.host + "/" + key;
            //   console.log(url);
            const res = await axios.post(this.ossObj.host, formData);

            if (res.status == 204) {
                success(url);
            } else {
                success("上传失败了");
            }
        },
    },
    created () {
    }
  }
  </script>
   
  <style>
  </style>